import { Button, Text, Hide, Show } from '@chakra-ui/react';
import { CloseIcon } from '@chakra-ui/icons';

const ClearFiltersButton = ({ onResetAll }: { onResetAll: () => void }) => {
  return (
    <Button
      variant="white"
      size="sm"
      w={{ base: '36px', sm: 'unset' }}
      px={{ base: '0', sm: '20px' }}
      mr={{ base: '0', sm: '10px' }}
      ml={{ base: '5px', sm: '0' }}
      onClick={onResetAll}
    >
      <Hide below="sm">
        <Text
          textStyle="bodyFamilyRegular"
          textTransform="none"
          fontWeight="500"
          lineHeight="28px"
        >
          Clear filters
        </Text>
      </Hide>
      <Show below="sm">
        <CloseIcon />
      </Show>
    </Button>
  );
};

export default ClearFiltersButton;
